const checkoutPageES = {
    activateTitle: "Activa tu negocio",
    activateSubtitle: "Completa tu suscripción para empezar a aceptar reservas.",
    totalSeats: "Asientos totales",
    staffSeats: "Asientos de personal",
    poweredBy: "Pagos seguros gestionados por Paddle",
    stillThere: "¿Sigues ahí?",
    continue: "Continuar",
};
export default checkoutPageES